export default __webpack_public_path__ + "static/media/turing.d9fbfbcd.gif";